import {
  Paper,
  Grid,
  Box,
  type PaperProps,
  type BoxProps,
  type GridProps,
  useTheme,
} from '@mui/material';
import type { ReactNode } from 'react';

type CardProps = PaperProps & {
  headerLeftElement?: ReactNode;
  headerRightElement?: ReactNode;
  children?: ReactNode;
  contentProps?: BoxProps;
  headerProps?: GridProps;
  headerLeftProps?: GridProps;
  headerRightProps?: GridProps;
};

export const Card = (props: CardProps) => {
  const {
    headerLeftElement,
    headerRightElement,
    children,
    contentProps,
    headerProps,
    headerLeftProps,
    headerRightProps,
    ...cardProps
  } = props;
  const theme = useTheme();
  const borderColor =
    theme.palette.mode === 'dark' ? theme.palette.black[850] : theme.palette.gray[100];

  return (
    <Paper
      elevation={0}
      {...cardProps}
      sx={{
        border: `1px solid ${borderColor}`,
        borderRadius: 3,
        overflow: 'hidden',
        ...cardProps.sx,
      }}
    >
      {(headerLeftElement ?? headerRightElement) && (
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          px={2}
          py={1.5}
          spacing={2}
          borderBottom="1px solid"
          borderColor="divider"
          wrap="nowrap"
          {...headerProps}
        >
          <Grid size="grow" {...headerLeftProps}>
            {headerLeftElement}
          </Grid>
          <Grid size="auto" {...headerRightProps}>
            {headerRightElement}
          </Grid>
        </Grid>
      )}
      <Box {...contentProps}>{children}</Box>
    </Paper>
  );
};
